/*
    Enable the enter to submit the form
*/
define('shared/initializer/form/adapters/mixins/EnterToSubmit',[
    '$',
    'shared/lib/RSVP'
], 
function ( $, RSVP ) {
    'use strict';

    function Ctor() { }

    Ctor.prototype.doPageLoad = function( ) {
        var me = this;
        
        me.$form.on('keydown', 'input', function(evt){
            if (evt.keyCode === 13) {
                me.$form.submit();
            }
        });

        return RSVP.resolve();
    };

    return Ctor;
});
